import React from 'react';
import { batteryToText } from 'utils/utils';
import statusConverter from 'utils/statusConverter';

export const columnSetter = (moduleScn, flag) => {
  const columns = [
    {
      Header: 'No',
      accessor: 'rnum',
    },
    {
      Header: '설비번호',
      accessor: 'areaNo',
    },
    {
      Header: '설비명',
      accessor: 'areaNm',
    },
    {
      Header: '감지기No.',
      accessor: 'modelNm',
    },
    {
      Header: (
        <span>
          wind(m/s)
        </span>
      ),
      accessor: 'wind',
    },
    {
      id: 'status',
      Header: () => <div>상태</div>,
      Cell: ({ row }) => statusConverter(row.original.status, row.original.statusCode),
    },
    {
      id: 'Battery',
      Header: () => <div>Battery(%)</div>,
      Cell: ({ row }) => batteryToText(row.original.battery),
    },
    {
      Header: '측정시간',
      accessor: 'regDate',
    },
  ];

  return columns;
};
